import React, { FC, useEffect, useRef, useState } from 'react';
import MultiInputItem from './item/MultiInputItem';
import { Dirary } from '../../../types/dirary';
import classes from './MultiInputDetail.module.scss';
import { useTheme } from '@mui/material';
import { Buttons } from '../../uikit/atoms/buttons/Buttons';
import SendIcon from '@mui/icons-material/Send';
//追加
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ScrollButton from '../../uikit/atoms/buttons/ScrollButton';
import { useNavigate } from 'react-router-dom';
import { useAddPosts, validateWorkerList } from '../../../hooks/api/posts/useAddPosts';
import { useDeletePosts } from '../../../hooks/api/posts/useDeletePosts';
import { useUpdatePosts } from '../../../hooks/api/posts/useUpdatePosts';
import { toast } from 'react-toastify';
import { useRecoilState } from 'recoil';
import {
  diaryListState,
  diaryListStateForMatrix,
} from '../../../states/diaryListState';
import { postIdCounterState } from '../../../states/postIdCounterState';
import { WorkerWithDiary } from '../../../types';

type Props = {
  diaryList: Array<Dirary>;
  // addDiaryList: Array<Dirary>;
  // deleteDiaryList: Array<Dirary>;
  // updateDiaryList: Array<Dirary>;
  setDiaryList: React.Dispatch<React.SetStateAction<Array<Dirary>>>;
  defaultDiary: Dirary;
  isSendable: boolean;
  totalTime: { hour: number; min: number; text: string };
  setTotalTime: React.Dispatch<
    React.SetStateAction<{ hour: number; min: number; text: string }>
  >;
  setWorkerList: React.Dispatch<React.SetStateAction<Array<WorkerWithDiary>>>;
  workerList: Array<WorkerWithDiary>;
};
const MultiInputDetail: FC<Props> = (props) => {
  const { addPostsAllWorkers } = useAddPosts();
  const navigation = useNavigate();
  const addPosts = useAddPosts();
  // const deletePosts = useDeletePosts();
  // const updatePosts = useUpdatePosts();
  const addButtonRef = useRef<HTMLDivElement>(null);
  const targetRef = useRef<HTMLDivElement>(null);
  const scrollRef = useRef<HTMLDivElement>(null);
  const [recoilDairyList, setRecoilDiaryList] =
    useRecoilState<Dirary[]>(diaryListState);

  const [recoilDiaryListForMatrix, setRecoilDiaryListForMatrix] =
    useRecoilState<Dirary[]>(diaryListStateForMatrix);
  const {
    diaryList,
    setDiaryList,
    totalTime,
    setTotalTime,
    defaultDiary,
    isSendable,
    // deleteDiaryList,
    // addDiaryList,
    // updateDiaryList,
    setWorkerList,
    workerList,
  } = props;
  const [addButtonDisabled, setAddButtonDisabled] = useState(true);
  //新規発行IDカウンタ
  const [postIdCounter, setPostIdCounter] = useRecoilState(postIdCounterState);
  // const [newId, setNewId] = useState(-1);
  const theme = useTheme();
  // const [totalTime, setTotalTime] = useState({
  //   hour: 0,
  //   min: 0,
  //   text: "00時間00分",
  // });
  //更新ボタンが押されたときのイベント
  const onSave = async () => {
    try {
      // 作業者リストの社員マスタ情報バリデーション
      const validation = validateWorkerList(workerList);
      if (!validation.valid) {
        toast.error(
          `社員マスタ情報（部署・工場・役職）が不足しています: ${validation.invalidWorkerNames.join(', ')}`,
          { autoClose: 5000 }
        );
        return;
      }

      await addPostsAllWorkers(diaryList, workerList);

      //成功したらメイン画面を表示する
      navigation('/');
    } catch {
      console.log('APIの実行に失敗しました');
    }
  };
  //デバッグ用

  // const createTimeText = (min: number) => {
  //   if (min <= 0) {
  //     return `${totalTime.text} ※作業時間が0です`;
  //   }
  //   if (parentTotalTime.min !== min) {
  //     return `${totalTime.text} ※作業時間が不一致です`;
  //   }
  //   return `${totalTime.text} 　OK`;
  // };
  //追加ボタンが押されたときのイベント
  const handleClickAddButton = () => {
    if (diaryList.length === 0) {
      //日報が１つも存在しない場合
      const newDiary = { ...defaultDiary, id: postIdCounter };
      setDiaryList((prevList) => [...prevList, newDiary]);
      setPostIdCounter((preCounter) => preCounter - 1);
    } else {
      //日報が存在する場合
      const newDiaryList = [...diaryList];
      const lastDiary = diaryList[diaryList.length - 1];
      const newDiary = {
        ...lastDiary,
        id: postIdCounter,
        isDisabled: false,
        comment: '',
      };
      newDiaryList.push(newDiary);
      // newDiaryList.push(diaryList[diaryList.length - 1]);
      setDiaryList(newDiaryList);
      setPostIdCounter((preCounter) => preCounter - 1);
    }
  };
  useEffect(() => {
    if (
      workerList.length === 0 ||
      workerList.some((worker) => worker.isDiaryExist === true)
    ) {
      setAddButtonDisabled(true);
    } else {
      setAddButtonDisabled(false);
    }
  }, [workerList]);
  useEffect(() => {
    // 追加ボタンの位置までスクロール
    if (addButtonRef.current) {
      addButtonRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'center',
      });
    } else {
      console.log('addButtonRef.current is null');
    }
  }, [diaryList.length]);
  return (
    <div className={classes.rootContainer}>
      <div className={classes.header}>
        <div className={classes.totalTime}>
          <p>合計作業時間</p>
          <div
            style={{
              color:
                totalTime.hour <= 0
                  ? theme.palette.error.main
                  : theme.palette.foreColor.main,
              // theme.palette.foreColor.main,
            }}
          >
            {totalTime.text}
          </div>
        </div>

        <div className={classes.updateButton}>
          <p>更新</p>
          <Buttons
            disabled={!isSendable}
            onClick={onSave}
            caption={'更新'}
            icon={<SendIcon />}
            width={26}
            height={26}
            fontSize={24}
          />
        </div>
      </div>
      <div className={classes.detail} ref={scrollRef}>
        <div ref={targetRef}></div>
        {diaryList.map((diary, index) => (
          <MultiInputItem
            key={diary.id}
            id={diary.id}
            diaryList={diaryList}
            setDiaryList={setDiaryList}
            setTotalTime={setTotalTime}
          />
        ))}
        <div className={classes.addButton} ref={addButtonRef}>
          <Buttons
            disabled={addButtonDisabled}
            onClick={handleClickAddButton}
            caption={''}
            icon={<AddCircleIcon />}
            width={24}
            height={24}
            fontSize={24}
          />
        </div>
        <ScrollButton targetElm={targetRef} scrollElm={scrollRef} />
      </div>
    </div>
  );
};

export default MultiInputDetail;
